import React, { useEffect, useState } from "react";
import { AppLayout } from "../../../layouts";
import { Header, NavAndTabs, Sides } from "../../../components";
import { Col, Container, Row } from "react-bootstrap";
import ComposeMessage from "./composeMessage";
import MessageHistory from "./messageHistory";
import { useNavigate, useParams } from "react-router-dom";
import { actionDoctor } from "../../../redux/actions";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const MassMessgaes = ({ loginData }) => {
    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(id || "compose-message");
    useEffect(() => {
        dispatch(actionDoctor.getMassMessages(loginData.userGuid));
    }, [dispatch, loginData.userGuid]);

    const onTabChange = (tabId) => {
        setActiveTab(tabId);
        navigate(`/doctor/mass-messages/${tabId}`);
    };
    const tabs = [
        {
            id: "compose-message",
            label: t("doctor.Mass_Messages.compose_message"),
            content: <ComposeMessage loginData={loginData} setActiveTab={setActiveTab} />,
            disabled: false,
        },
        {
            id: "message-history",
            label: t("doctor.Mass_Messages.message_history"),
            content: <MessageHistory loginData={loginData} setActiveTab={setActiveTab} />,
            disabled: false,
        },
    ];
    const rightSide = (
        <Container fluid className="exado-container1">
            <Row className="exado-row1">
                <Col>

                    <Header.HeadingPage pageHeading={`${t("Mass_Messages")} / ${tabs.find((tab) => tab.id === activeTab)?.label || t("doctor.Mass_Messages.compose_message")}`} />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col>
                    <NavAndTabs.NavAndTabs
                        tabs={tabs}
                        activeTab={activeTab}
                        onTabChange={onTabChange}
                    />
                </Col>
            </Row>
        </Container>
    );
    return (
        <AppLayout.AppLayoutOne
            leftSide={<Sides.LeftSides loginData={loginData} />}
            rightSide={rightSide}
        />
    );
};

export default MassMessgaes;
